import React from 'react';
import Link from '../menu/link';
import { NavLink } from 'react-router-dom';
import LogoDark from "../../img/LogoDark.png";

const Footer = (props) => {
    const { links } = props;
    return (
        <footer className='z-30 flex flex-col lg:flex-row flex-none items-center lg:justify-around gap-6 lg:gap-0 p-8 lg:p-10 bg-darkblue border-t-2 border-bluegrey'>
            <NavLink to='/' className='h-12 order-1'>
                <img src={LogoDark} alt="Homebutler logo" className='h-12' />
            </NavLink>
            {links && (
                <div className='flex flex-row flex-wrap justify-center gap-x-8 gap-y-3 order-2'>
                    <Link textColor='white' href='#section1'>Home</Link>
                    <Link textColor='white' href='#section2'>What we do</Link>
                    <Link textColor='white' href='#section25'>Services</Link>
                    <Link textColor='white' href='#section3'>How it works</Link>
                    <Link textColor='white' href='#section4'>Pricing</Link>
                    <NavLink className='text-white hover:text-blue' to='/blog'>Blog</NavLink>
                    <NavLink className='text-white hover:text-blue' to='/locations'>Locations</NavLink>
                </div>
            )}
            {!links && (
                <div className='flex flex-row flex-wrap justify-center gap-x-8 gap-y-3 order-2'>
                    <NavLink className='text-white hover:text-blue' to='/blog'>Blog</NavLink>
                    <NavLink className='text-white hover:text-blue' to='/locations'>Locations</NavLink>
                </div>
            )}
            <p className='order-3 hidden lg:block invisible'>Get early access</p>
        </footer>
    );
};

export default Footer;
